var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.56444 16.4018C13.3762 16.4018 16.4663 13.3118 16.4663 9.49999C16.4663 5.6882 13.3762 2.59814 9.56444 2.59814C5.75266 2.59814 2.6626 5.6882 2.6626 9.49999L2.6626 16.4018H9.56444Z",
    stroke: "url(#paint0_linear_43_603)",
    strokeWidth: 1.38037,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_43_603",
    x1: 2.6626,
    y1: 2.59814,
    x2: 19.3061,
    y2: 8.89162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.158668,
    stopColor: "#F76A4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60652,
    stopColor: "#A24AE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891362,
    stopColor: "#4859F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.5848c8fecbde3735b8255bf5039448fd.svg";
export { ForwardRef as ReactComponent };